import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from '../../redux/title/action';
import { TextSmall } from '../../components/text';
import {
  InfoHeaderStyledContainer,
  RegisterStyledContainer,
} from '../../components/container/styles';
import { useGetRegProductList } from './hooks/useGetRegProductList';
import { RenderForm } from '../../components/forms';
import {
  FORM_PIC,
  FORM_PRODUCT_DATA_BASE,
  FORM_PRODUCT_MOBILE_PAIR,
  FORM_SHOW_IMAGE_WARRANTY,
} from './form';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';

import { Button, Checkbox, Row, Spin, Typography } from 'antd';
import { ROUTES_PATH } from '../../resources/routes-name';
import { styleGapform } from './styles/styles';
import liff from '@line/liff';

export const RegisterProduct = () => {
  const dispatch = useDispatch();
  const [isAccepted, setIsAccepted] = useState(false);
  const {
    getValues,
    setValue,
    control,
    mobileBrandList,
    channelBuyList,
    onSubmit,
    handleSubmit,
    isLoadingBarcode,
    mobileFields,
    canAddMobileRow,
    canRemoveMobileRow,
    onAddMobileRow,
    onRemoveMobileRow,
  } = useGetRegProductList();

  useEffect(() => {
    dispatch(setTitle('ลงทะเบียนรับประกันสินค้า'));
  }, [dispatch]);

  const registerProductData = useSelector((state) => state.registerProduct);

  useEffect(() => {
    if (registerProductData && registerProductData.productId) {
      localStorage.setItem('registerProductData', JSON.stringify(registerProductData));
    }
  }, [registerProductData]);

  useEffect(() => {
    const storedregisterProductData = localStorage.getItem('registerProductData');
    if (storedregisterProductData) {
      const parsedData = JSON.parse(storedregisterProductData);
      const { mobileBrandId, mobileModelName, mobiles: storedMobiles, ...rest } = parsedData;
      Object.keys(rest).forEach((key) => {
        setValue(key, rest[key]);
      });
      if (Array.isArray(storedMobiles) && storedMobiles.length > 0) {
        setValue('mobiles', storedMobiles);
      } else if (
        (mobileBrandId != null && mobileBrandId !== '') ||
        (mobileModelName && String(mobileModelName).trim())
      ) {
        setValue('mobiles', [
          {
            mobileBrandId: mobileBrandId ?? undefined,
            mobileModelName: mobileModelName || '',
          },
        ]);
      }
    }
  }, [setValue, registerProductData]);

  const handlePolicyClick = () => {
    liff.openWindow({
      url: ROUTES_PATH.ROUTE_TERM_WARRANTY.PATH,
      external: true,
    });
  };
  const handleCheckboxChange = (e) => {
    setIsAccepted(e.target.checked);
  };

  return (
    <Spin spinning={isLoadingBarcode}>
      <RegisterStyledContainer>
        <InfoHeaderStyledContainer>
          <TextSmall
            text={<span>กรุณากรอกข้อมูลเพื่อลงทะเบียนรับประกันสินค้า</span>}
            style={{
              color: '#8c6e19',
            }}
            bold
          />
        </InfoHeaderStyledContainer>
        <div style={{ padding: '30px', paddingBottom: '70px' }}>
          <RenderForm
            control={control}
            getValues={getValues}
            setValue={setValue}
            forms={FORM_PRODUCT_DATA_BASE({ channelBuyList })}
          />
          {mobileFields.map((field, index) => (
            <div key={field.id}>
              <RenderForm
                control={control}
                getValues={getValues}
                setValue={setValue}
                forms={FORM_PRODUCT_MOBILE_PAIR({ mobileBrandList, index })}
              />
              {canRemoveMobileRow && (
                <Row justify="end" style={{ marginBottom: 8 }}>
                  <Button type="link" danger onClick={() => onRemoveMobileRow(index)}>
                    ลบรายการนี้
                  </Button>
                </Row>
              )}
              {index === mobileFields.length - 1 && canAddMobileRow && (
                <Row style={{ marginBottom: 16 }}>
                  <Button type="default" block onClick={onAddMobileRow}>
                    + เพิ่มยี่ห้อและรุ่น (สูงสุด 3 รายการ)
                  </Button>
                </Row>
              )}
            </div>
          ))}
          <div style={styleGapform}>
            <RenderForm
              control={control}
              getValues={getValues}
              setValue={setValue}
              forms={FORM_SHOW_IMAGE_WARRANTY()}
            />
            <RenderForm
              control={control}
              getValues={getValues}
              setValue={setValue}
              forms={FORM_PIC()}
            />
          </div>
          <div
            style={{
              ...styleGapform,
              marginTop: 10,
              gap: '16px',
            }}
          >
            <Checkbox checked={isAccepted} onChange={handleCheckboxChange}>
              <span style={{ color: 'inherit' }}>ฉันได้ยอมรับ</span>
            </Checkbox>
            <Row justify="center">
              <Typography.Link onClick={() => handlePolicyClick(true)} underline>
                ข้อตกลงการรับประกันสินค้า
              </Typography.Link>
            </Row>
            <ContainerButton center>
              <ButtonTheme
                useFor="CONFIRM_REG"
                disabled={!isAccepted}
                onClick={() => {
                  handleSubmit(onSubmit)();
                }}
              />
            </ContainerButton>
          </div>
        </div>
      </RegisterStyledContainer>
    </Spin>
  );
};
